import { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './InnerLayout.module.css';

type TProps = {
  headingComponent?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  hasSidebar?: boolean;
  maxWidth?: string;
};

export const InnerLayout = ({
  headingComponent,
  children,
  className,
  contentClassName,
  hasSidebar = false,
  maxWidth = '100%',
}: TProps) => {
  return (
    <div className={clsx({ [styles.hasSidebar]: hasSidebar })}>
      <div style={{ maxWidth }} className={clsx(styles.container, className)}>
        {headingComponent}
        <div className={clsx(styles.children, contentClassName)}>
          {children}
        </div>
      </div>
    </div>
  );
};
